import { Slide, Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import { MdStarBorder } from "react-icons/md";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Home.css";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import home_IR_1 from "../../assets/images/home_IR_1.webp";
import home_IR_2 from "../../assets/images/home-IR_2.webp";
import home_IR_3 from "../../assets/images/WASTE3-768x512.webp";
import Home_about_1 from "../../assets/images/Home_about_1.webp";
import Home_about_2 from "../../assets/images/logist.webp";
import Home_hero__bg1 from "../../assets/images/dredging.2311161610522.webp";
import Home_hero__bg2 from "../../assets/images/jf-martin-E-Zl0aLRQK8-unsplash.webp";
import Home_hero__bg3 from "../../assets/images/marine-768x1024.webp";
import { BsArrowRight } from "react-icons/bs";

function Home() {
  const containerRef1 = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [test1, setTest1] = useState(false);
  const [count, setCount] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const callbackFunction1 = (entries) => {
    const [entry] = entries;
    setTest1(entry.isIntersecting);
    if (test1 == true) {
      if (count <= 10) {
        setCount(count + 1);
      }
      if (count2 <= 403) {
        setCount2(count2 + 1);
      }
      if (count3 <= 407) {
        setCount3(count3 + 2);
      }
    }
  };

  const options1 = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
  };

  useEffect(() => {
    const observer1 = new IntersectionObserver(callbackFunction1, options1);
    if (containerRef1.current) observer1.observe(containerRef1.current);
    return () => {
      if (containerRef1.current) observer1.unobserve(containerRef1.current);
    };
  }, [containerRef1, options1]);

  const divStyle = {
    background: "center",
    backgroundSize: "cover",
    minHeight: "60vh",
  };
  const slideImages = [
    {
      url: Home_hero__bg1,
      caption: "Slide 1",
      h3: "Welcome to GuineGulf Energy",
      h1: "Driving Innovation in Energy and Logistics",
      p: "GuineGulf Energy is a leading provider of comprehensive energy and marine solutions, committed to sustainable development and operational excellence across Nigeria and West Africa.",
    },
    {
      url: Home_hero__bg2,
      caption: "Slide 2",
      h3: "Empowering Progress",
      h1: "Delivering Seamless Logistics and Energy Solutions",
      p: "From marine logistics to vessel handling and waste management, we provide state-of-the-art services that enhance efficiency and create value for industries and communities.",
    },
    {
      url: Home_hero__bg3,
      caption: "Slide 3",
      h3: "Sustainability in Action",
      h1: "Building a Better Future Together",
      p: "At GuineGulf Energy, we prioritize environmentally responsible practices across all our operations. From waste management to innovative logistics, we are dedicated to sustainable growth that benefits businesses and the environment alike.",
    },
  ];

  const buttonStyle = {
    display: "none",
  };

  const properties = {
    prevArrow: <button style={{ ...buttonStyle }}></button>,
    nextArrow: <button style={{ ...buttonStyle }}></button>,
  };

  const navigate = useNavigate();

  return (
    <div>
      <Header />
      <div className="home__main">
        <section className="slide-container ">
          <Fade {...properties}>
            {slideImages.map((slideImage, index) => (
              <div key={index}>
                <div
                  className="home__main__section__one"
                  style={{
                    ...divStyle,
                    backgroundImage: `url(${slideImage.url})`,
                  }}
                >
                  <h3>{slideImage.h3}</h3>
                  <h1>{slideImage.h1}</h1>
                  <p>{slideImage.p}</p>
                  <button
                    onClick={() => {
                      navigate("/about/glance");
                    }}
                  >
                    Learn more
                  </button>
                </div>
              </div>
            ))}
          </Fade>
          <div></div>
        </section>
        <section className="home__main__section__two">
          <div className="home__main__section__two__start">
            <h3>We are GuineGulf Energy</h3>
            <h1>Empowering Industries Through Marine and Energy Solutions</h1>
            <hr />
            <p>
              GuineGulf Energy is redefining excellence in Nigeria and Africa's
              energy and marine sectors. With expertise in trading, marine
              logistics, vessel handling, and waste management, we deliver
              innovative and sustainable solutions tailored to meet diverse
              industrial needs.
            </p>
          </div>
          <div className="home__main__section__two__end">
            <img src={Home_about_1} alt="" />
            <img src={Home_about_2} alt="" />
          </div>
        </section>
        <section className="home__main__section__three">
          <div className="home__main__section__three__start">
            <div>
              <h1>Our Business</h1>
              <hr />
            </div>
            <p>
              At GuineGulf Energy, we deliver exceptional solutions across
              Nigeria's marine and energy sectors. From marine logistics and
              vessel handling to waste management and equipment leasing, we
              provide comprehensive services that drive operational efficiency.
              Our commitment to innovation and sustainability ensures we remain
              a trusted partner in the industry.
            </p>
          </div>
          <div className="home__main__section__three__end">
            <div>
              <img
                src={home_IR_1}
                alt=""
                className="home__main__section__three__end__img"
              />
              <h1>Marine Logistics</h1>
              <p>
                We deliver exceptional solutions across Africa's marine and
                energy sectors. From marine logistics to waste management and
                equipment leasing, we provide services that drive operational
                efficiency.
              </p>
            </div>
            <div>
              <img
                src={home_IR_2}
                alt=""
                className="home__main__section__three__end__img"
              />
              <h1>Vessel Handling & Brokerage</h1>
              <p>
                Our expert team ensures efficient vessel handling and brokerage
                services, connecting clients with the best solutions for their
                maritime needs.
              </p>
            </div>
            <div>
              <img
                src={home_IR_3}
                alt=""
                className="home__main__section__three__end__img"
              />
              <h1>Waste Management</h1>
              <p>
                We prioritize sustainability by offering waste management
                solutions that minimize environmental impact and adhere to
                regulatory standards.
              </p>
              <h3
                onClick={() => {
                  navigate("/operations");
                }}
              >
                View all our operations <BsArrowRight />
              </h3>
            </div>
          </div>
        </section>
        <section className="home__main__section__four">
          <div className="home__main__section__four__ratings">
            <div>
              <MdStarBorder className="home__main__section__four__icon" />
              <h3>Quality Service</h3>
            </div>
            <div>
              <MdStarBorder className="home__main__section__four__icon" />
              <MdStarBorder className="home__main__section__four__icon" />
              <h3>Customer Satisfaction</h3>
            </div>
            <div>
              <MdStarBorder className="home__main__section__four__icon" />
              <MdStarBorder className="home__main__section__four__icon" />
              <MdStarBorder className="home__main__section__four__icon" />
              <h3>Operational Excellence</h3>
            </div>
          </div>
          <h1>GuineGulf Energy: Innovating for Growth</h1>
          <h3>
            At GuineGulf Energy, we are committed to delivering exceptional
            services in marine logistics, vessel handling, and energy
            operations. Our portfolio spans a diverse range of services,
            including waste management, dredging equipment leasing, shipping
            agency, and offshore logistics, all aimed at driving growth and
            value across Nigeria and Africa. With a focus on sustainability and
            innovation, we prioritize environmental responsibility, customer
            satisfaction, and collaboration with local communities and
            stakeholders.
          </h3>
        </section>

        <section className="home__main___section___five">
          <div className="home__main__section__five__bg">
            <div className="home__main__section__five__fg">
              <div className="primary_one">
                <p>
                  GuineGulf Energy has made significant investments in
                  cutting-edge marine logistics infrastructure and vessel
                  handling facilities.
                </p>
              </div>
              <div className="primary_one">
                <p>
                  We pride ourselves on our well-structured logistics and supply
                  systems, ensuring efficient delivery of services.
                </p>
              </div>
              <div className="primary_one">
                <p>
                  We are committed to providing sustainable solutions across the
                  offshore and onshore sectors.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
